import type { ChatRepository } from '@src/domain/chat/repository/chat.repository';

/**
 * Disconnect from Chat Use Case
 * Handles disconnecting from chat service
 */
export class DisconnectFromChatUseCase {
    constructor(private readonly chatRepository: ChatRepository) { }

    execute(): void {
        this.chatRepository.disconnect();
    }
}
